var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownMultiselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2910_6592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39795 15H41.6428C43.2659 15 44.5816 16.3431 44.5816 18V30.7755C44.5816 32.4324 43.277 33.7755 41.654 33.7755C32.2161 33.7755 10.4894 33.7755 5.88775 33.7755",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.186 23.1631L36.9848 26.0203L39.7837 23.1631",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31633 19H2.45918C1.37716 19 0.5 19.8954 0.5 21V28C0.5 29.1046 1.37716 30 2.45918 30H9.31633C10.3984 30 11.2755 29.1046 11.2755 28V21C11.2755 19.8954 10.3984 19 9.31633 19Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9696 19H15.194C14.112 19 13.2349 19.8954 13.2349 21V28C13.2349 29.1046 14.112 30 15.194 30H25.9696C27.0516 30 27.9287 29.1046 27.9287 28V21C27.9287 19.8954 27.0516 19 25.9696 19Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2910_6592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownMultiselect);
export default __webpack_public_path__ + "static/media/dropdown-multiselect.0806f6829f58ad98bfc4e6f513c97b2c.svg";
export { ForwardRef as ReactComponent };